// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"t9-z"};